import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as state from '../../../../../../state'

import * as components from './components'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.page.Component,
    ds.overlay.slideout.Component,
    ds.table.Component,
    components.FilterSlideout.Component,
  ],
  selector: 'atn-rate-reports-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class AtnReportListComponent {
  public readonly reportsEc = ngCore.inject(state.rate.reports.Collection)
  public readonly meFeature = ngCore.inject(state.me.Feature)
  private readonly _router = ngCore.inject(router.Router)

  /** Canonical table input for the reports list. */
  public readonly tableConfig = {
    collection: this.reportsEc,
    view: {
      search: true,
      title: 'Reports',
    },
  } satisfies ds.table.ec.Config.Input<state.rate.reports.TypeParams>

  public readonly showFilterSlideout = false

  public rowClickHandler(report: state.rate.reports.Entity): void {
    const source = 'Table.Row.Clicked'

    this.reportsEc.plugins.selectionPlugin.applied.actions.putInSelectionLookup
      .from(source)
      .dispatch({ value: { set: report.label.id } })

    const url = this.meFeature.contexts.selectors
      .getUrlForLink({
        goto: {
          navigationId: ents.extra.prebuilt.AppPageAlias.Report,
        },
      })
      .asSignal()
    if (url) {
      // TODO: maybe this should be done in an effect that listens for the previous action
      this._router.actions.navigate.from(source).dispatch({ url })
    }
  }

  public filterButtonClickHandler(): void {
    console.log('TODO')
  }

  public slideoutBackdropClickHandler(): void {
    console.log('TODO')
  }

  public slideoutCloseBtnClickHandler(): void {
    console.log('TODO')
  }
}
